import { render } from "./HeaderSearch.vue?vue&type=template&id=65f1a3fc"
import script from "./HeaderSearch.vue?vue&type=script&lang=js"
export * from "./HeaderSearch.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/HeaderSearch.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "65f1a3fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('65f1a3fc', __exports__)) {
    api.reload('65f1a3fc', __exports__)
  }
  
  module.hot.accept("./HeaderSearch.vue?vue&type=template&id=65f1a3fc", () => {
    api.rerender('65f1a3fc', render)
  })

}


export default __exports__